import React from "react";
import { Modal } from "react-bootstrap";
import { FloatingText, OneButton } from "../components";

function Modal_TwoInput({
  backdrop=false, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  header,
  onChange,
  onChange2,
  value,
  value2,
  placeholder='',
  placeholder2='',
  onClick
}) {

  function handleChange(event){
    event.preventDefault()
    onChange(event.target.value)
  };

  function handleChange2(event){
    event.preventDefault()
    onChange2(event.target.value)
  };


  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      className='loading-screen'
    >
      <Modal.Header closeButton>
        <h3>{header}</h3>
      </Modal.Header>
      <Modal.Body style={styles.container}  >
        <FloatingText
            name={placeholder}
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
        />
        <FloatingText
            name={placeholder2}
            placeholder={placeholder2}
            onChange={handleChange2}
            value={value2}
        />
      </Modal.Body>
      <Modal.Footer>
            <OneButton {...{ text:'ยกเลิก', variant:"secondary", submit:onHide  }} />
            <OneButton {...{ text:'บันทึก', variant:"success", submit:onClick  }} />
      </Modal.Footer>
    </Modal>
  );
};

const styles = {
  container : {
    display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',zIndex:999
  }
}

export default Modal_TwoInput;